<template>
  <v-container
    id="detalhe-melhoresentregas-produtores"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
            style="max-width: 100%"
          >
            <v-container>
              <v-col
                cols="12"
              >
                <dashboard-filtro-produtores
                  :primeiro="enablePrimeiroDia"
                  :ultimo="enableUltimoDia"
                  :empresas="enableEmpresa"
                  :url="link"
                  :produtores="enableProdutores"
                  :linhas="enableLinha"
                />
              </v-col>
            </v-container>
            <v-divider class="mb-5" />
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <dashoard-card-view
                  :exibir-texto-titulo="true"
                  :componente-auxiliar="true"
                  :text="'Relatório Entrega de leite de novos Produtores'"
                  :padding="dynamicPaddingBloco"
                  :texto-information="textoDetalhesMelhoresEntregas"
                  :code-information="'349'"
                  :exibir-informacao="true"
                  :headers-detalhamento="headersDetalhamento"
                  :dados-detalhamento="dadosDetalhamento"
                  :variacao-diferenca="true"
                  :variacao-qtd="true"
                  :loading="loading"
                  :style-object="styleObject"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

      <script>
  import Entregaleite from '../../../../../services/entregaleite'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardMelhoresEntregasLeiteProdutores',
    emits: ['atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashboardFiltroProdutores: () => import('../../../components/core/FiltroProdutores.vue'),
      DashoardCardView: () => import('../../../components/core/CardView.vue'),
    },
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      paginaEnable: false,
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      select: JSON.parse(localStorage.getItem('empresaSelect')),
      empresa: [],
      produtorSelect: JSON.parse(localStorage.getItem('produtorSelect')),
      produtores: [],
      linhaSelect: JSON.parse(localStorage.getItem('linhaSelect')),
      rotaleite: [],
      menu: false,
      menu1: false,
      loading: false,
      error: null,
      codigo: 0,
      orientacao: [],
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableLinha: true,
      enableProdutores: true,
      link: window.location.href,
      textoDetalhesMelhoresEntregas: '',
      headersDetalhamento: [
        { text: 'Produtor', value: 'produtor', class: 'black--text title' },
        { text: 'Quantidade de leite ano anterior(Litros)', value: 'quantidade_anterior', align: 'right', class: 'black--text title' },
        { text: 'Quantidade de leite(Litros)', value: 'quantidade_atual', align: 'right', class: 'black--text title' },
        { text: 'Diferença (Litros)', value: 'diferenca_anual', align: 'right', class: 'black--text title' },
        { text: 'Variação qtd. anual (%)', value: 'varicao_quantidade', align: 'right', class: 'black--text title' },
        { text: 'Preço médio', value: 'precomedio', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dynamicPaddingBloco: '',
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },
    },
    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      window.scrollTo(0, 0)

      eventEmit.$emit('atualizar_texto', 'Produtores')

      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoProdutor'))
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }

      this.enableTexto('349')
      this.updateDynamicPadding()
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, produtor, linha) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.produtorSelect = produtor
        this.linhaSelect = linha

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)

        this.updateDate()
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      enableTexto (value) {
        var i = 0

        this.codigo = value
        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '349') {
            this.textoDetalhesMelhoresEntregas = this.orientacao[i].descricao
          }
        }
        return this.textoDetalhesMelhoresEntregas
      },

      getColor (value, mediador) {
        var porcentagem = value
        if (typeof value === 'string') {
          porcentagem = parseFloat(value.replace(',', '.'))
        }

        return porcentagem >= mediador ? 'color: green' : 'color: red'
      },

      formateNum (num) {
        return num.toLocaleString('pt-BR', { maximumFractionDigits: 0 })
      },

      updateDate () {
        this.dadosDetalhamento = []
        this.showDelhamentoMelhoresEntregasProdutores()
      },

      async showDelhamentoMelhoresEntregasProdutores () {
        this.loading = true
        await Entregaleite.showDelhamentoMelhoresEntregasProdutores(this.primeiroDia, this.ultimoDia, this.select, this.produtorSelect, localStorage.tokencontrato, this.linhaSelect).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.dadosMelhoresProdutores.map((item) => {
              var listaDetalhamento = ({
                produtor: item.nome_produtor,
                quantidade_atual: this.formateNum(item.quantidade_atual),
                quantidade_anterior: this.formateNum(item.quantidade_anterior),
                diferenca_anual: item.quantidade_atual - item.quantidade_anterior,
                varicao_quantidade: item.varicao_quantidade.toFixed(2).toString().replace('.', ',') + '%',
                precomedio: 'R$' + item.precocota.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }),
              })

              return listaDetalhamento
            })
          } else if (resposta.data.msg === 'Não há dados para o período selecionado') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingBloco = 'padding-right: 97rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingBloco = 'padding-right: 65rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingBloco = 'padding-right: 4rem !important'
        } else if (window.innerWidth > 1000 && window.innerWidth <= 1380) {
          this.dynamicPaddingBloco = 'padding-right: 66rem !important'
        } else if (window.innerWidth > 600 && window.innerWidth <= 1000) {
          this.dynamicPaddingBloco = 'padding-right: 32rem !important'
        } else {
          this.dynamicPaddingBloco = 'padding-right: 60rem !important'
        }
      },
    },
  }
</script>

<style lang="sass">
  // #bloco1
    // margin-left: -5rem

  #relatorioProdutoresAtivos
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationMelhoresProdutores
    margin-left: 9.5rem
    font-weight: bold

  #headersMelhoresProdutores
    margin-left: 1.7rem
    margin-right: 1.7rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
